<div class="app" (window:resize)="platformService.onResize($event)" [ngClass]="{'app--warning-open': (utilsService.isMobile && autenticado && !isRoot && showWarning) || (validacaoCorretora?.periodoTeste && autenticado && !isRoot)}">
    <input class="extensao" type="text" id="bExtensaoExterno" tabindex="-1">
    
    <!-- Warning Periodo de teste-->
        @if (autenticado && !isRoot && showWarning) {

            @if (!utilsService.isMobile && validacaoCorretora?.periodoTeste) {
                <div class="warning align-items-center" [ngClass]="{'warning--desktop': !utilsService.isMobile}">
                    <span class="warning__text" [ngClass]="{'text-contratacao': rotaAtual === '/meu-plano'}">
                            Período de teste restante:
                            {{
                                validacaoCorretora ?
                                validacaoCorretora.prazo == 1 ? validacaoCorretora.prazo + " dia" :
                                validacaoCorretora.prazo == 0 ? "Último dia!" :
                                validacaoCorretora.prazo + " dias" : ''
                            }} 
                    </span>
                    <button class="warning__close" mat-icon-button (click)="handleEsconderWarning()">
                        <mat-icon [svgIcon]="'close'" [ngStyle]="{'color': 'var(--primary)'}"></mat-icon>
                    </button>
                </div>
            }
        }

    <div class="app__container" [ngStyle]="{'grid-template-columns': utilsService.isMobile || !autenticado ? '1fr' : '', 'padding': utilsService.isMobile || !autenticado ? '0' : ''}">

        @if (!utilsService.isMobile && autenticado && ((apiUsuario.finalizouLogin() && apiUsuario.fezLogin()) || !apiUsuario.fezLogin())) {
            <app-sidebar></app-sidebar>
        }

        <div class="app__main">
            <!-- Box de Termos e Politicas -->
            <div class="div-frontal" *ngIf="!isRoot && mostrarTermos && autenticado && ((apiUsuario.finalizouLogin() && apiUsuario.fezLogin()) || !apiUsuario.fezLogin())" >
                <div class="conteudo-modal">
                    <h2 class="titulo-termos">Confirmação de Termos e Políticas</h2>
                    <h3>Para utilizar o sistema, aceite nossos termos de uso. Ao marcar a caixa abaixo, você concorda com as condições. Se tiver dúvidas, consulte nossa política de privacidade.</h3>
                   
                    <ul>
                        <li class="checkTermos">
                            <mat-checkbox [(ngModel)]="contrato"  class="example-margin">Confirmo que li e concordo com o <a href="{{payload.contrato}}" target="_blank">Contrato</a></mat-checkbox>
                            <mat-checkbox [(ngModel)]="termoUso"  class="example-margin"> Confirmo que li e concordo com os <a href="{{payload.termosUso}}" target="_blank">Termos de uso</a></mat-checkbox>
                            <mat-checkbox [(ngModel)]="privacidade" class="example-margin"> Confirmo que li e concordo com as <a href="{{payload.politicasPrivacidade}}" target="_blank">Políticas de privacidade</a></mat-checkbox>
                        </li>
                    </ul>
        
                    <button [disabled]="loaderTermos" (click)="aceitarTermos()" class="my-btn nova-tarefa  my-btn--sz-md"
                        [ngClass]="{'my-btn--disabled': loaderTermos || !termoUso || !contrato || !privacidade}">Continuar
                       <mat-icon
                        *ngIf="loaderTermos"
                        iconPositionEnd
                        [svgIcon]="'loading'"
                        [ngClass]="['loading']"></mat-icon>
                    </button>
                </div>
            </div>
        
            @if (!utilsService.isMobile && autenticado && ((apiUsuario.finalizouLogin() && apiUsuario.fezLogin()) || !apiUsuario.fezLogin())) {
                <app-header></app-header>
            }
        
            <div *ngIf="autenticado && ((apiUsuario.finalizouLogin() && apiUsuario.fezLogin()) || !apiUsuario.fezLogin()) && platformService.virtualDeviceType !== 'desktop'" class="container-tool-bar-mobile">
                <div class="container-titulo-logo" [ngClass]="recolheItensMenu ? 'container-titulo-logo__open' : ''">
                    <img src="../assets/logos/agger/logo-vertical-txt-white.png" class="logo" (click)="goToCotacoes()">
                </div>
                <div class="container-actions">
                    <tool-bar-actions *ngIf="rotaAtual" class="tool-bar-actions" #toolBarActions
                        [showIfAuthorizedName]="toolBarActionsConfigs[rotaAtual]?.showIfAuthorizedName"
                        [showSearch]="toolBarActionsConfigs[rotaAtual]?.busca"
                        [mostraFiltro]="toolBarActionsConfigs[rotaAtual]?.filtro"
                        [placeholder]="toolBarActionsConfigs[rotaAtual]?.placeholder">
                    </tool-bar-actions>
                    <menu-hamburger></menu-hamburger>
                </div>
            </div>
        
            <div class="container-menu-hamburguer-mobile" *ngIf="autenticado && ((apiUsuario.finalizouLogin() && apiUsuario.fezLogin()) || !apiUsuario.fezLogin()) && platformService.virtualDeviceType !== 'desktop'"
                [ngClass]="{'container-menu-hamburguer-mobile__open': menuToggle}">
        
                <app-menu-mobile
                    [sessao]="sessao"
                    [isRoot]="isRoot"
                    (logoutEvent)="logout()"
                    (rotaLinkEvent)="receiveRotaLinkMenuMobileEvent($event)"
                ></app-menu-mobile>
        
            </div>
        
            <!-- Conteúdo principal -->
            <div 
                class="app__content"
                [ngStyle]="!autenticado ? {'height': '100vh', 'margin': 0} : {}"
            >    
                <!-- CONTEUDO PRINCIPAL DAS ROTAS -->
                <router-outlet></router-outlet>        
            </div>

            
            
            @if (autenticado && ((apiUsuario.finalizouLogin() && apiUsuario.fezLogin()) || !apiUsuario.fezLogin()) && rotaAtual !== '/config-usuarios' && rotaAtual !== '/config-coberturas') {
                <div class="app-navbar-mobile">
                    <app-navbar-mobile></app-navbar-mobile>
                </div>
            }
        </div>

        <div class="app__filter">
            <filtro></filtro>
        </div>
        
    </div>
    
</div>

<tour-step-template>
    <!-- Tour Step Personalizado -->
    <ng-template let-step="step">
        <app-tour-step 
            [step]="step"
        ></app-tour-step>
    </ng-template>
</tour-step-template>